import React from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../sass/style.scss';
import '../../sass/green-theme-override.css';
import WhatsAppToggle from '../../components/WhatsAppToggle';


const App = () => {

  return (
    <div className="App" id='scrool'>
      <AllRoute />
      <ToastContainer />
      <WhatsAppToggle phoneNumber="1234567890" message="Hello! I'm interested in your services." />
    </div>
  );

}

export default App;
